module.exports = __webpack_public_path__ + "6a33b108ea4ebbe1cd452fc42de8cdbf.svg";